import * as React from "react";

const MenuIcon = (props) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 24 17"
        {...props}
    >
        <path d="M23.5,3H.5a.5.5,0,0,0,0,1h23a.5.5,0,0,0,0-1Zm0,16H.5a.5.5,0,0,0,0,1h23a.5.5,0,0,0,0-1ZM.5,11h23a.5.5,0,0,1,0,1H.5a.5.5,0,0,1,0-1Z" />
    </svg>
)

export default MenuIcon;
